<div class="content-search" [class.no-widgets]="!hasWidgets">
    <div class="switch">
      @if (groupSearchTabs) {
        @for (group of widgets; track trackByPosition) {
          @if (group?.['key']) {
            <div class="homeSearchDesktop__group-title">
              <app-ds-typography
                [tag]="'p'"
                [fontFamily]="fontFamily.Regular"
                [size]="fontSize.Smaller"
                [color]="fontColor.Secondary"
                [text]="group?.['key'] | transloco | uppercase">
              </app-ds-typography>
            </div>
          }
          @for (widget of group?.['value']; track trackByPosition) {
            <app-ds-chip-action
              [label]="widget.title | transloco"
              [icon]="widget.icon"
              [type]="chipActionType"
              [branding]="widget.chipBranding"
              [chipStatus]="getChipStatus(moduleSelected(widget.searchType))"
              (clickEvent)="onClickSwitch(widget.searchType)">
            </app-ds-chip-action>
          }
        }
      } @else {
        @for (widget of widgets; track trackByPosition) {
          <app-ds-chip-action
            [label]="widget?.['title'] | transloco"
            [icon]="widget?.['icon']"
            [type]="chipActionType"
            [branding]="widget?.['chipBranding']"
            [chipStatus]="getChipStatus(moduleSelected(widget?.['searchType']))"
            (clickEvent)="onClickSwitch(widget?.['searchType'])">
          </app-ds-chip-action>
        }
      }
    </div>

    <ng-container [ngSwitch]="switchSelected">
      <ng-container *ngSwitchCase="searchType.HOME_FLIGHT">
        <app-search-bar
          [destination]="landingDestination"
          [source]="source"
          [searchType]="switchSelected"
          [airports]="airports$ | async">
        </app-search-bar>
      </ng-container>
      <ng-container *ngSwitchCase="searchType.HOME_BUSES">
        <app-search-bar
          [source]="source"
          [searchType]="switchSelected"
          [airports]="airports$ | async">
        </app-search-bar>
      </ng-container>
      <ng-container *ngSwitchCase="searchType.HOME_HOTELS">
        <div class="content-search-hotel">
          <app-hotel-search
            [source]="source"
            [searchType]="switchSelected">
          </app-hotel-search>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="searchType.PACKAGES_HOME">
        <app-packages-search-bar
          [source]="source"
          [searchType]="switchSelected">
      </app-packages-search-bar>
      </ng-container>

      <ng-container *ngSwitchCase="searchType.TOUR_AND_ACTIVITIES">
        <app-activities-search-bar
          [source]="source"
          [searchBarBehavior]="searchBarBehavior">
        </app-activities-search-bar>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <app-no-module-available [searchType]="switchSelected"></app-no-module-available>
      </ng-container>
    </ng-container>
  </div>
